import React, { Component, useEffect, useState } from 'react';
import {  Routes, Route, Link, Navigate } from 'react-router-dom';
import { withRouter } from "./Components/helpers/withRouter";
import './App.css';
import CheckListStep from './Views/CheckListStep';
import CreateCheckList from './Views/CreateCheckList';
import InformationStep from './Views/InformationStep';
import MainAccordion from './Views/MainAccordion';
import PerformTraining from './Views/PerformTraining';
import VideoModelStep from './Views/VideoModelStep';
import SelectTraining from './Views/SelectTraining';
import MediaCapture from './Views/MediaCapture';
import ScrollToTop from './Components/layout/ScrollToTop';
import packageJson from '../package.json';
import {v4 as uuid} from 'uuid';
import {isIncognito} from './utils/incognitoDetector';

import { openDB } from "idb";
import { Spinner, Modal, ModalHeader, ModalBody, Alert } from 'reactstrap';
import { getMimeType } from './utils/extensionHelper';
import { convertCafToWav, convertHeicToPng, convertMovToMp4 } from './utils/fileConverter';
import ToastMessage from './Components/layout/ToastMessage';

import ReactGA from 'react-ga4';

const DB_NAME = "INSTRUCTJS_DB";
const STORE_NAMES = ["trainings", "media"]; // add as many as you need

const uiModes = ['UI: Step-by-Step', 'UI: Accordion'];

async function initDB() {
  return openDB(DB_NAME, 2, {
    upgrade(db) {
      STORE_NAMES.forEach((storeName) => {
        if (!db.objectStoreNames.contains(storeName)) {
          db.createObjectStore(storeName, { keyPath: "id" });
        }
      });
    },
  });
}

export function isGuid(str){
  const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return guidRegex.test(str);
}

class App extends Component {
  constructor(props) {
    super(props);

    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID || 'G-0000000000');

    const storedUiMode = window.localStorage.getItem("uiInUse");
    
    const params = new URLSearchParams(window.location.search);
    const storedTestingMode = params.get("testing");
    const evalMode = !storedTestingMode; //!!params.get('eval-mode');

    this.state = {
      trainingFromParams: params.get('id'),
      evalMode: evalMode, // force this to a boolean. Only true if has value and that value is true
      trainings: [],
      currentTraining: null,
      currentStep: null,
      uiInUse: (uiModes.includes(storedUiMode) && !evalMode) ? storedUiMode : uiModes[1], // default to first mode
      incognitoBrowser: false,
      incognitoAlertVisible: false,
      showTour:false
    };
    window.updateState = this.updateState.bind(this);
    window.getMediaById = this.getMediaById.bind(this);
  }

  async componentDidMount() {
    this.loadTrainingFromParams();
    this.loadTrainings();
    const incognitoBrowser = await isIncognito();
    this.setState({ incognitoBrowser, incognitoAlertVisible: incognitoBrowser });

    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search});
    this.setState({currentPath: window.location.pathname + window.location.search});
  }

  handleCloseIncognitoAlert = () => {
    this.setState({ incognitoAlertVisible: false });
  }

  componentDidUpdate(prevProps, prevState){
    console.log("*** App.componentDidUpdate, prevState:", prevState, " newState:", this.state);
    if(window.location.pathname + window.location.search !== this.state.currentPath){
      ReactGA.send({ 
        hitType: "pageview", 
        page: window.location.pathname + window.location.search
      });
      this.setState({currentPath: window.location.pathname + window.location.search});
    }
    // if (this.state.currentPath && this.state.currentPath.includes('/perform-training') && window.screen && window.screen.orientation) {
    //   window.screen.orientation.lock('landscape').catch(err => {
    //     console.warn('Could not lock orientation:', err);
    //   });
    // }
  }

  async loadTrainingFromParams(){
    // when picking locally, trainings are in C:\inetpub\wwwroot\Files\Public
    if(!this.state.trainingFromParams) return;
    var serverPath = window.location.origin + '/Files/Public/';
    if(serverPath.includes('localhost'))
      serverPath = 'http://localhost/Files/Public/';
    var trainingPath = serverPath + this.state.trainingFromParams + '/' + this.state.trainingFromParams + '.json';
    console.log("Loaded training from params:", this.state.trainingFromParams, " from training path", trainingPath);
    try{
      var response = await fetch(trainingPath, {
        mode: 'cors',
      });
      var training = await response.json();
      if(training){
        //old format of export file
        const db = await initDB();
        for(let i = 0; i < training.Steps.length; ++i){
          const downloadPromises = [];
          training.Steps[i].ImageFilepath = this.fixPath(training.Steps[i].ImageFilepath, training.HomeDirectory, serverPath);
          if(training.Steps[i].ImageFilepath){
            downloadPromises.push(fetch(training.Steps[i].ImageFilepath)
              .then(response => response.blob())
              .then(async (imageFile) =>{
                if (imageFile) {
                  const imageId = uuid();
                  const filename = training.Steps[i].ImageFilepath.split('/').pop();
                  let imageBlob = null; 
                  let mimeType = '';

                  // ✅ Detect and convert HEIC/HEIF files
                  if (/\.heic$/i.test(filename) || /\.heif$/i.test(filename)) {
                    console.log(`Converting ${filename} from HEIC to PNG...`);
                    try {
                      imageBlob = await convertHeicToPng(imageFile, 'png');
                      mimeType = 'image/png';
                    } catch (err) {
                      console.error(`HEIC conversion failed for ${filename}:`, err);
                      training.Steps[i].ImageFilepath = null;
                      return;
                    }
                  }else{
                    mimeType = getMimeType(filename);
                    imageBlob = new Blob([imageFile], { type: mimeType });
                  }

                  const mediaRecord = {
                    id: imageId,
                    file: imageBlob,
                    type: mimeType,
                    date: imageBlob.lastModified ? new Date(imageFile.lastModified) : new Date(),
                    trainings: [this.state.trainingFromParams],
                  };
                  await db.add(STORE_NAMES[1], mediaRecord);
                  training.Steps[i].ImageFilepath = imageId;
                }else{
                  training.Steps[i].ImageFilepath = null; // clear invalid reference
                }
              })
              .catch(error => {
                console.error("Error fetching media file:", error)
                return null;
              }));
          }
          training.Steps[i].AudioFilepath = this.fixPath(training.Steps[i].AudioFilepath, training.HomeDirectory, serverPath);
          if(training.Steps[i].AudioFilepath){
            downloadPromises.push(fetch(training.Steps[i].AudioFilepath)
              .then(response => response.blob())
              .then(async (audioFile) => {
                if (audioFile) {
                  const arrayBuffer = await audioFile.arrayBuffer();
                  const header = new TextDecoder().decode(new Uint8Array(arrayBuffer).slice(0, 4));
                  let finalBlob = null;
                  let mimeType = '';

                  // ✅ Detect format
                  if (header === 'caff') {
                    console.warn('CAF detected — converting to WAV...');
                    finalBlob = await convertCafToWav(arrayBuffer);
                    mimeType = 'audio/wav';
                  }else {
                    mimeType = getMimeType(training.Steps[i].AudioFilepath.split('/').pop());
                    finalBlob = new Blob([arrayBuffer], { type: mimeType });
                  }

                  const audioId = uuid();
                  const mediaRecord = {
                    id: audioId,
                    file: finalBlob,
                    type: mimeType,
                    date: audioFile.lastModified ? new Date(audioFile.lastModified) : new Date(),
                    trainings: [this.state.trainingFromParams],
                  };
                  await db.add(STORE_NAMES[1], mediaRecord);
                  training.Steps[i].AudioFilepath = audioId;
                } else {
                  training.Steps[i].AudioFilepath = null; // clear invalid reference
                }
              })
              .catch(error => {
                console.error("Error fetching media file:", error)
                return null;
              }));
          }
          training.Steps[i].VideoFilepath = this.fixPath(training.Steps[i].VideoFilepath, training.HomeDirectory, serverPath);
          if(training.Steps[i].VideoFilepath){
            downloadPromises.push(fetch(training.Steps[i].VideoFilepath)
              .then(response => response.blob())
              .then(async (videoFile) => {
                if (videoFile) {
                  const filename = training.Steps[i].VideoFilepath.split('/').pop();
                  let videoBlob = null;
                  let mimeType = '';

                  // ✅ Detect and fix MOV rotation
                  if (/\.mov$/i.test(filename)) {
                    console.log(`Re-encoding ${filename} to fix rotation...`);
                    try {
                      videoBlob = await convertMovToMp4(videoFile);
                      mimeType = 'video/mp4';
                    } catch (err) {
                      console.error(`MOV conversion failed for ${filename}:`, err);
                      training.Steps[i].VideoFilepath = null;
                      return;
                    }
                  }else{
                    mimeType = getMimeType(filename);
                    videoBlob = new Blob([videoFile], { type: mimeType });
                  }

                  const videoId = uuid();
                  const mediaRecord = {
                    id: videoId,
                    file: videoBlob,
                    type: mimeType,
                    date: videoFile.lastModified ? new Date(videoFile.lastModified) : new Date(),
                    trainings: [this.state.trainingFromParams],
                  };
                  await db.add(STORE_NAMES[1], mediaRecord);
                  training.Steps[i].VideoFilepath = videoId;
                }else{
                  training.Steps[i].VideoFilepath = null; // clear invalid reference
                }
              })
              .catch(error => {
                console.error("Error fetching media file:", error)
                return null;
              }));
          }
          training.Steps[i].ContentImagePath = this.fixPath(training.Steps[i].ContentImagePath, training.HomeDirectory, serverPath);
          if(training.Steps[i].ContentImagePath){
            downloadPromises.push(fetch(training.Steps[i].ContentImagePath)
              .then(response => response.blob())
              .then(async (imageFile) => {
                if (imageFile) {
                  const imageId = uuid();
                  const filename = training.Steps[i].ContentImagePath.split('/').pop();
                  let imageBlob = null; 
                  let mimeType = '';

                  // ✅ Detect and convert HEIC/HEIF files
                  if (/\.heic$/i.test(filename) || /\.heif$/i.test(filename)) {
                    console.log(`Converting ${filename} from HEIC to PNG...`);
                    try {
                      imageBlob = await convertHeicToPng(imageFile, 'png');
                      mimeType = 'image/png';
                    } catch (err) {
                      console.error(`HEIC conversion failed for ${filename}:`, err);
                      training.Steps[i].ImageFilepath = null;
                      return;
                    }
                  }else{
                    mimeType = getMimeType(filename);
                    imageBlob = new Blob([imageFile], { type: mimeType });
                  }                  const mediaRecord = {
                    id: imageId,
                    file: imageBlob,
                    type: mimeType,
                    date: imageFile.lastModified ? new Date(imageFile.lastModified) : new Date(),
                    trainings: [this.state.trainingFromParams],
                  };
                  await db.add(STORE_NAMES[1], mediaRecord);
                  training.Steps[i].ContentImagePath = imageId;
                }else{
                  training.Steps[i].ContentImagePath = null; // clear invalid reference
                }
              })
              .catch(error => {
                console.error("Error fetching media file:", error)
                return null;
              }));
          }
          await Promise.all(downloadPromises);
        }
        training.CheckList = training.Steps?.find(s => s.Index === 0)?.Training?.CheckList?.filter(item => item.Step !== "Preview Checklist" && item.Step !== "Review Checklist") || [];
        console.log("Setting currentTraining from params:", this.state.trainingFromParams, " to", training);
        this.setState({      
          // trainings: [...prev.trainings, training],
          currentTraining: training
        });
      }else{
        trainingPath = serverPath + this.state.trainingFromParams + '/' + this.state.trainingFromParams + '.zip';
        var response = await fetch(trainingPath, {
          mode: 'cors',
        });
        if(response.ok){
          const JSZip = (await import('jszip')).default;
          const zip = await JSZip.loadAsync(response.blob());
          const jsonFile = Object.keys(zip.files).find(name => name.endsWith('.json'));
          await this.importZipFile(zip, jsonFile, true);
        }
      }
    }catch(error){
      console.error(error);
      try{
        trainingPath = serverPath + this.state.trainingFromParams + '/' + this.state.trainingFromParams + '.zip';
        var response = await fetch(trainingPath, {
          mode: 'cors',
        });
        if(response.ok){
          const JSZip = (await import('jszip')).default;
          const zip = await JSZip.loadAsync(response.blob());
          const jsonFile = Object.keys(zip.files).find(name => name.endsWith('.json'));
          await this.importZipFile(zip, jsonFile, true);
        }
      }catch(err){
        console.error(err);
      }
    }
  }

  fixPath(wholePath, homeDirectory, newHomeLocation){
    if(wholePath){
      var relativePath = wholePath.slice(wholePath.indexOf(homeDirectory));
      var newPath = newHomeLocation + relativePath;
      return newPath;
    }
    return wholePath;
  }

  async loadTrainings() {
    const db = await initDB();
    const storeName = STORE_NAMES[0]; // first one in the list
    const trainings = await db.getAll(storeName);
    // if(trainings){
    console.log("Loaded trainings from IndexedDB:", trainings);
    this.setState(
      {
        trainings, 
        trainingsLoaded: true
      }, 
      () => {
        this.removeExtraMedia();
      }
    );
    // }
  }

  async removeExtraMedia(){
    if(!this.state.trainingsLoaded){ return; }
    const curTrainings = [...this.state.trainings.map(t => t.Id), this.state.trainingFromParams];
    const db = await initDB();
    const mediaItems = db.getAll(STORE_NAMES[1]);
    for(const media in mediaItems)
    {
      if(media.trainings && media.trainings.length > 0 && !media.trainings.some(t => curTrainings.has(t))){
        db.delete(STORE_NAMES[1], media.Id);
      }
    }
  }

  updateState(stateUpdate, callback){
    const prevState = this.state;
    this.setState(stateUpdate, async () => {
      // resolve the new state (if stateUpdate was a function, use this.state after setState)
      const newState = this.state;
      console.log("State updated. Old state:", prevState, " New state:", newState);
      
      // Store uiInUse in localStorage if it changed
      if (newState.uiInUse !== prevState.uiInUse) {
        window.localStorage.setItem("uiInUse", newState.uiInUse);
      }
      
      const db = await initDB();

          // figure out which keys were updated
      const updatedKeys =
        typeof stateUpdate === "function"
          ? Object.keys(stateUpdate(newState, this.props) || {})
          : Object.keys(stateUpdate || {});
      console.log("Updated keys:", updatedKeys);

      if(updatedKeys.includes("currentTraining") && newState.currentTraining) {
        console.log("updating currentTraining: ", newState.currentTraining);
        await db.put(STORE_NAMES[0], newState.currentTraining);
      }
      if (updatedKeys.includes("currentStep") && newState.currentStep) {
        console.log("updating currentStep: ", newState.currentStep);
        let steps = newState.currentTraining.Steps ?? [];
        const idx = steps.findIndex(s => s.id === newState.currentStep.id);

        if (idx >= 0) {
          // update existing step
          steps[idx] = { ...steps[idx], ...newState.currentStep };
        } else {
          // add step if it doesn’t exist
          steps = steps.map(step =>
            step.Index >= newState.currentStep.Index
              ? { ...step, Index: step.Index + 1 }
              : step
          );
          steps = [...steps, newState.currentStep];
        }

        steps.sort((a, b) => a.Index - b.Index);
        steps.forEach((step, index) => {step.Index = index;})
        newState.currentTraining.Steps = steps;

        console.log("Saving training with updated Steps:", newState.currentTraining);
        await db.put(STORE_NAMES[0], newState.currentTraining);
      }
      if(updatedKeys.includes("trainings")) {
        console.log("updating trainings: ", newState.trainings);
        if(prevState.trainings.length > newState.trainings.length) {
          console.log("Deleting training from DB that was removed from state:", prevState.trainings.find(t => !newState.trainings.includes(t)));
          await db.delete(STORE_NAMES[0], prevState.trainings.find(t => !newState.trainings.includes(t)).id);
        }
      }
      if(updatedKeys.includes('tempMessage')){
        if(newState.tempMessage){
          if(newState.tempMessageTimeoutId)
            clearTimeout(newState.tempMessageTimeoutId)
          if(newState.tempMessage && !(newState.tempMessage.duration < 0)){
            this.setState({tempMessageTimeoutId: setTimeout(() => {
                this.setState({tempMessage: null});
                clearTimeout(this.state.tempMessageTimeoutId)
              }, newState.tempMessage.duration ?? 5000)
            });
          }
        }else{
          this.setState({tempMessageTimeoutId: null});
        }
      }
      this.loadTrainings();
      if(callback) callback();
    });
  }

  getMediaById = async (media) => {
    return new Promise((resolve, reject) => {
      if(!media){
        resolve(null);
        return;
      }
      if(!isGuid(media)){
        resolve(media);
        return;
      }

      const request = indexedDB.open(DB_NAME);

      request.onsuccess = function (event) {
        const db = event.target.result;
        const transaction = db.transaction(STORE_NAMES[1], "readonly");
        const store = transaction.objectStore(STORE_NAMES[1]);

        const getRequest = store.get(media); // looks up by primary key

        getRequest.onsuccess = function () {
          resolve(getRequest.result); // null if not found
        };

        getRequest.onerror = function () {
          reject(getRequest.error);
        };
      };

      request.onerror = function () {
        reject(request.error);
      };
    });
  }

  getMediaForTraining = async (trainingId) => {
    const db = await initDB();
    const allMedia = await db.getAll(STORE_NAMES[1]);
    return allMedia.filter(m => m.trainings?.includes(trainingId));
  }

  importJsonFile = async (file) => {
    // Import from JSON
    const text = await file.text();
    let exportData;
    try {
      exportData = JSON.parse(text);
    } catch {
      // Try to parse legacy format
      exportData = JSON.parse(text.replace(/^"Training":/, '{ "Training":').replace(/"Media Files":/, '"Media Files":'));
    }
    if (!exportData.Training) {
      alert('Invalid export file.');
      return;
    }
    exportData.Training.id = this.state.trainings.length > 0 ? Math.max(...this.state.trainings.map(t => t.id)) + 1 : 1;
    this.props.updateState((prev) => ({
      trainings: [...prev.trainings, exportData.Training]
    }));
  }

  importZipFile = async (zip, jsonFile, temporary) => {
    const jsonStr = await zip.file(jsonFile).async('string');
    const exportData = JSON.parse(jsonStr);

    // Add training
    const importedTraining = exportData.Training;
    if (this.state.trainings.find(t => t.Id === importedTraining.Id)) {
      alert('Training with this ID already exists.');
      return;
    }
    importedTraining.id = this.state.trainings.length > 0 ? Math.max(...this.state.trainings.map(t => t.id)) + 1 : 1;
    if(temporary){
      importedTraining.HomeDirectory = this.state.trainingFromParams;
      this.setState({      
        currentTraining: importedTraining
      });
    }else{
      this.setState((prev) => ({
        trainings: [...prev.trainings, importedTraining]
      }));
    }

    // Add media files
    if (exportData["Media Files"] && exportData["Media Files"].length > 0) {
      const db = await initDB();
      for (const mediaMeta of exportData["Media Files"]) {
        var existing = await this.getMediaById(mediaMeta.id);
        if(existing){
          if (!existing.trainings) {
            existing.trainings = [];
          }
          if (!existing.trainings.includes(importedTraining.Id)) {
            existing.trainings.push(importedTraining.Id);
            await db.put(STORE_NAMES[1], existing);
          }
        }else{
          const mediaBlob = await zip.file(mediaMeta.id).async('blob');
          // Save to DB using your existing method
          const mediaRecord = { ...mediaMeta, file: mediaBlob };
          await db.add(STORE_NAMES[1], mediaRecord);
        }
      }
    }
  }

  importMauiExport = async (zip, jsonFile, temporary) => {
    const jsonStr = await zip.file(jsonFile).async('string');
    var importedTraining = JSON.parse(jsonStr);
    // Add training
    if (this.state.trainings.find(t => t.Id === importedTraining.Id)) {
      alert('Training with this ID already exists.');
      return;
    }

    const db = await initDB();
    for(const step of importedTraining.Steps){
      if(step.AudioFilepath){
        const audioFilename = step.AudioFilepath.split('/').pop();
        const audioFileInZip = Object.keys(zip.files).find(name => name.endsWith(audioFilename));
        if (audioFileInZip) {
          const audioFile = await zip.file(audioFileInZip);
          // Read the file as ArrayBuffer so we can inspect the header
          const arrayBuffer = await audioFile.async('arraybuffer');
          const header = new TextDecoder().decode(new Uint8Array(arrayBuffer).slice(0, 4));
          
          let audioBlob = null;
          let mimeType = '';

          // ✅ Detect format
          if (header === 'caff') {
            console.warn('CAF detected — converting to WAV...');
            audioBlob = await convertCafToWav(arrayBuffer);
            mimeType = 'audio/wav';
          }else {
            mimeType = getMimeType(audioFilename);
            audioBlob = new Blob([arrayBuffer], { type: mimeType });
          }

          const audioId = uuid();
          const mediaRecord = {
            id: audioId, 
            file: audioBlob, 
            type: audioBlob.type, 
            date: audioFile.lastModified ? new Date(audioFile.lastModified) : new Date(), 
            trainings: temporary ? [this.state.trainingFromParams]: [importedTraining.Id] 
          };
          await db.add(STORE_NAMES[1], mediaRecord);
          step.AudioFilepath = audioId;
        }else{
          step.AudioFilepath = null; // clear invalid reference
        }
      }
      if(step.VideoFilepath){
        const videoFilename = step.VideoFilepath.split('/').pop();
        const videoFileInZip = Object.keys(zip.files).find(name => name.endsWith(videoFilename));
        if (videoFileInZip) {
          const videoFile = await zip.file(videoFileInZip);
          const rawBlob = await videoFile.async('blob');
          let videoBlob = null;
          let mimeType = '';

          if (/\.mov$/i.test(videoFilename)) {
            console.log(`Re-encoding ${videoFilename} to fix rotation...`);
            try {
              videoBlob = await convertMovToMp4(rawBlob);
              mimeType = 'video/mp4';
            } catch (err) {
              console.error(`MOV conversion failed for ${videoFilename}:`, err);
              step.VideoFilepath = null;
              return;
            }
          }else{
            mimeType = getMimeType(videoFilename);
            videoBlob = new Blob([rawBlob], { type: mimeType });
          }

          const videoId = uuid();
          const mediaRecord = {
            id: videoId,
            file: videoBlob,
            type: videoBlob.type,
            date: videoFile.lastModified ? new Date(videoFile.lastModified) : new Date(),
            trainings: temporary ? [this.state.trainingFromParams]: [importedTraining.Id] 
          };
          await db.add(STORE_NAMES[1], mediaRecord);
          step.VideoFilepath = videoId;
        }else{
          step.VideoFilepath = null; // clear invalid reference
        }
      }
      if(step.ImageFilepath){
        const imageFilename = step.ImageFilepath.split('/').pop();
        const imageFileInZip = Object.keys(zip.files).find(name => name.endsWith(imageFilename));
        if (imageFileInZip) {
          const imageFile = await zip.file(imageFileInZip);
          const rawBlob = await imageFile.async('blob');
          let imageBlob = null;
          let mimeType = '';

          // ✅ Convert HEIC/HEIF files using ffmpeg.wasm (v0.11+)
          if (/\.heic$/i.test(imageFilename) || /\.heif$/i.test(imageFilename)) {
            console.log(`Converting ${imageFilename} from HEIC to PNG...`);
            try {
              imageBlob = await convertHeicToPng(rawBlob, 'png');
              mimeType = 'image/png';
            } catch (err) {
              console.error(`HEIC conversion failed for ${imageFilename}:`, err);
              step.ImageFilepath = null;
              return;
            }
          }else{
            mimeType = getMimeType(imageFilename);
            imageBlob = new Blob([rawBlob], { type: mimeType });
          }

          const imageId = uuid();
          const mediaRecord = {
            id: imageId,
            file: imageBlob,
            type: imageBlob.type,
            date: imageFile.lastModified ? new Date(imageFile.lastModified) : new Date(),
            trainings: temporary ? [this.state.trainingFromParams]: [importedTraining.Id] 
          };
          await db.add(STORE_NAMES[1], mediaRecord);
          step.ImageFilepath = imageId;
        }else{
          step.ImageFilepath = null; // clear invalid reference
        }
      }
      if(step.ContentImagePath){
        const imageFilename = step.ContentImagePath.split('/').pop();
        const imageFileInZip = Object.keys(zip.files).find(name => name.endsWith(imageFilename));
        if (imageFileInZip) {
          const imageFile = await zip.file(imageFileInZip);
          const rawBlob = await imageFile.async('blob');
          let imageBlob = null;
          let mimeType = '';

          // ✅ Convert HEIC/HEIF files using ffmpeg.wasm (v0.11+)
          if (/\.heic$/i.test(imageFilename) || /\.heif$/i.test(imageFilename)) {
            console.log(`Converting ${imageFilename} from HEIC to PNG...`);
            try {
              imageBlob = await convertHeicToPng(rawBlob, 'png');
              mimeType = 'image/png';
            } catch (err) {
              console.error(`HEIC conversion failed for ${imageFilename}:`, err);
              step.ImageFilepath = null;
              return;
            }
          }else{
            mimeType = getMimeType(imageFilename);
            imageBlob = new Blob([rawBlob], { type: mimeType });
          }

          const imageId = uuid();
          const mediaRecord = {
            id: imageId,
            file: imageBlob,
            type: imageBlob.type || 'image/png',
            date: imageFile.lastModified ? new Date(imageFile.lastModified) : new Date(),
            trainings: temporary ? [this.state.trainingFromParams]: [importedTraining.Id] 
          };
          await db.add(STORE_NAMES[1], mediaRecord);
          step.ContentImagePath = imageId;
        }else{
          step.ContentImagePath = null; // clear invalid reference
        }
      }
    }
    importedTraining.id = this.state.trainings.length > 0 ? Math.max(...this.state.trainings.map(t => t.id)) + 1 : 1;
    importedTraining.CheckList = importedTraining.Steps?.find(s => s.Index === 0)?.Training?.CheckList?.filter(item => item.Step !== "Preview Checklist" && item.Step !== "Review Checklist") || [];
    if(temporary){
      this.setState({      
        currentTraining: importedTraining
      });
      return;
    }
    this.setState((prev) => ({
      trainings: [...prev.trainings, importedTraining]
    }));
  }

  importTraining = async (event) => {
    // alert("Import is not yet supported in this app.");
    // return;
    const file = event.target.files[0];
    if (!file) return;

    // Check if it's a zip or json
    if (file.name.endsWith('.zip')) {
      // Import from zip
      const JSZip = (await import('jszip')).default;
      const zip = await JSZip.loadAsync(file);

      // Find the JSON file in the zip
      const jsonFile = Object.keys(zip.files).find(name => name.endsWith('_export.json'));
      if (jsonFile) {
        this.importZipFile(zip, jsonFile);
        alert('Import successful!');
      }else{
        const oldJsonFile = Object.keys(zip.files).find(name => name.endsWith('.json'));
        if(!oldJsonFile){
          alert('No export JSON found in zip.');
          return;
        }
        await this.importMauiExport(zip, oldJsonFile);
        alert('Import successful!');
      }
    } else if (file.name.endsWith('.json')) {
      await this.importJsonFile(file);
      alert('Import successful!');
    } else {
      alert('Unsupported file type.');
    }
    // Reset file input so user can import again
    event.target.value = '';
  }

  render() {
    const {location} =this.props;
    console.log("Rendering:", this.state, " with location", location);
    if (!this.state.currentTraining && location.pathname !== "/") {
      // window.location.replace("/");
      // return null;
      // return <Navigate to={`/${location.search}`} />;
      return (
        <Navigate
          to={{
            pathname: '/',
            search: location.search, // preserve query params
          }}
          replace
        />
      );
    }
    if(this.state.trainingFromParams && this.state.currentTraining && location.pathname !== "/perform-training")
    {
      // window.location.replace("/perform-training?id=" + this.state.trainingFromParams);
      // return null;
      // return <Navigate to={`/perform-training${location.search}`} />;
      return (
        <Navigate
          to={{
            pathname: '/perform-training',
            search: location.search, // preserve query params
          }}
          replace
        />
      );
    }

    const showLoadingModal = this.state.trainingFromParams && this.state.currentTraining?.HomeDirectory !== this.state.trainingFromParams;
    let linkState = 2;
    if(!this.state.trainingFromParams){
      if(location.pathname === '/')
        linkState = 0;
      else if(!this.state.trainingFromParams && location.pathname !== '/camera')
        linkState = 1;
    }

    return (
      <div className='instruct-display-bars'>
      <div className='instruct_background'>
      <ScrollToTop/>
      <div className="App">
        <header className="App-header">
          {this.state.tempMessage && 
          <ToastMessage
            showToast = {!!this.state.tempMessage}
            icon = {this.state.tempMessage.icon}
            title = {this.state.tempMessage.title}
            label = {this.state.tempMessage.label}
            message = {this.state.tempMessage.message}
          />}
          {this.state.incognitoAlertVisible && (
            <Alert color="warning" style={{fontSize: '.75em'}} toggle={this.handleCloseIncognitoAlert}>
              You are currently using incognito/private browsing mode. Please note that in this mode, your training data and media files may not be saved properly. For the best experience, we recommend using a standard browsing mode.
            </Alert>
          )}
          {!this.state.trainingFromParams && <div className='App-title' style={{  marginBottom: '1em', fontWeight: "bold"}}>
            <div>INSTRUCT</div>
          </div>}
          {/* <Alert color="warning" style={{fontSize: '.75em'}}>This site is currently under development</Alert> */}
          <nav className='function-bar' style={{ display: 'flex', justifyContent: 'space-between', width: '95%' }}>
            <span style={{marginLeft: 'auto', textAlign: "right" }}>
              {linkState === 0 &&
                <>
                  {!this.state.evalMode && (
                    <Link
                      className="App-link"
                      to="#"
                      onClick={e => {
                        e.preventDefault();
                        const currentIdx = uiModes.indexOf(this.state.uiInUse);
                        const nextIdx = (currentIdx + 1) % uiModes.length;
                        this.updateState({ uiInUse: uiModes[nextIdx] });
                      }}
                    >
                    {this.state.uiInUse}
                    </Link>
                  )}
                  {!this.state.evalMode && ' | '}
                  <Link className="App-link" 
                    to="#"
                    onClick={e => {
                      e.preventDefault();
                      this.fileInputRef && this.fileInputRef.click();
                    }}
                  >
                    Import Training
                  </Link>
                  <input
                    type="file"
                    accept=".json,.zip"
                    ref={ref => (this.fileInputRef = ref)}
                    style={{ display: "none" }}
                    onChange={this.importTraining}
                  />
                  {' | '}
                </>
              }
              {linkState === 1 && 
                <>
                  <Link className="App-link" style={{textAlign: "left" }} to={{ pathname: "/", search: this.props.location?.search || "" }}>Home</Link> 
                  {' | '}
                </>
              }
              <Link 
                className="App-link" 
                style={{marginLeft: "auto", textAlign: "right" }} 
                to="#"
                onClick={e => {
                  e.preventDefault();
                  this.updateState({ showTour: true });
                }}>
                  Help
              </Link>
            </span>             
          </nav>

          {showLoadingModal && (
            <Modal isOpen={true} centered={true}>
              <ModalHeader>Loading Training</ModalHeader>
              <ModalBody>
                <div className="text-center">
                  <Spinner>Loading...</Spinner>
                </div>
                <p>Content for the selected training is being downloaded.</p>
              </ModalBody>
            </Modal>
          )}
          <Routes>
            <Route
              path="/"
              element={
                <SelectTraining 
                  trainings={this.state.trainings}
                  updateState={window.updateState}
                  uiInUse={this.state.uiInUse}
                  evalMode={this.state.evalMode}
                  getMediaForTraining={this.getMediaForTraining}
                  showTour={this.state.showTour}
                  incognitoBrowser={this.state.incognitoBrowser}
                />
              }
            />
            <Route
              path="/checklist-step"
              element={
                <CheckListStep 
                  currentTraining={this.state.currentTraining} 
                  currentStep={this.state.currentStep}
                  updateState={window.updateState}
                  uiInUse={this.state.uiInUse}
                  evalMode={this.state.evalMode}
                  showTour={this.state.showTour}
                  incognitoBrowser={this.state.incognitoBrowser}
                />
              }
            />
            <Route
              path="/create-checklist"
              element={
                <CreateCheckList 
                  currentTraining={this.state.currentTraining} 
                  updateState={window.updateState}
                  uiInUse={this.state.uiInUse}
                  evalMode={this.state.evalMode}
                  showTour={this.state.showTour}
                  incognitoBrowser={this.state.incognitoBrowser}
                />
              }
            />
            <Route
              path="/information-step"
              element={
                <InformationStep 
                  currentTraining={this.state.currentTraining} 
                  currentStep={this.state.currentStep} 
                  updateState={window.updateState}
                  getMediaById={window.getMediaById}
                  uiInUse={this.state.uiInUse}
                  evalMode={this.state.evalMode}
                  showTour={this.state.showTour}
                  incognitoBrowser={this.state.incognitoBrowser}
                />
              }
            />
            <Route
              path="/main-accordion"
              element={
                <MainAccordion 
                  currentTraining={this.state.currentTraining} 
                  currentStep={this.state.currentStep}
                  AudioRecorder={window.recorderRef}
                  updateState={window.updateState} 
                  uiInUse={this.state.uiInUse}
                  evalMode={this.state.evalMode}
                  showTour={this.state.showTour}
                  incognitoBrowser={this.state.incognitoBrowser}
                />
              }
            />
            <Route
              path="/perform-training"
              element={
                <PerformTraining 
                  currentTraining={this.state.currentTraining} 
                  updateState={window.updateState} 
                  getMediaById={window.getMediaById}
                  uiInUse={this.state.uiInUse}
                  evalMode={this.state.evalMode}
                  showTour={this.state.showTour}
                  incognitoBrowser={this.state.incognitoBrowser}
                />
              }
            />
            <Route
              path="/video-model-step"
              element={
                <VideoModelStep 
                  currentTraining={this.state.currentTraining} 
                  currentStep={this.state.currentStep} 
                  updateState={window.updateState}
                  getMediaById={window.getMediaById}
                  uiInUse={this.state.uiInUse}
                  evalMode={this.state.evalMode}
                  showTour={this.state.showTour}
                  incognitoBrowser={this.state.incognitoBrowser}
                />
              }
            />
            <Route
              path="/camera"
              element={
                <MediaCapture 
                  currentTraining={this.state.currentTraining} 
                  currentStep={this.state.currentStep}
                  updateState={window.updateState}
                  uiInUse={this.state.uiInUse}
                  evalMode={this.state.evalMode}
                  showTour={this.state.showTour}
                  incognitoBrowser={this.state.incognitoBrowser}
                />
              }
            />
          </Routes>
          {!this.state.trainingFromParams && <div className='App-footer' style={{  marginBottom: '1em', fontWeight: "bold", fontSize: '.75em'}}>
            <div>v{packageJson.version}</div>
          </div>}
        </header>
      </div>
    </div>
    </div>
    );
  }
}

export default withRouter(App);
